import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {

  @Input() tooltipText: string;
  @Input() tooltipSize: TooltipSize = TooltipSize.Normal;

  onTooltipClick(tooltip: any, $event: Event) {
    $event.stopPropagation();
    $event.preventDefault();
    tooltip.toggle();
  }

  protected readonly TooltipSize = TooltipSize;
}

export enum TooltipSize {
  Normal = 'Normal',
  Small = 'Small'
}
